import React from "react";
import { Link } from "react-router-dom";
import MainFooter from "../shared/MainFooter.jsx";

const LegalPageShell = ({ title, children }) => (
  <div className="choice-landing min-h-screen bg-[#080b14] noise-overlay">
    <header className="border-b border-white/[0.05]">
      <div className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img src="/images/logo.png" alt="FractoLabs" className="w-full max-w-[100px]" />
        </Link>
        <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors">
          ← Back to home
        </Link>
      </div>
    </header>

    <main className="max-w-3xl mx-auto px-6 py-16">
      <h1 className="text-3xl md:text-4xl font-semibold text-white mb-8">{title}</h1>
      <div className="prose prose-invert prose-sm max-w-none text-gray-400 space-y-6">{children}</div>
    </main>

    <MainFooter />
  </div>
);

const TermsPage = () => (
  <LegalPageShell title="Terms of Service">
    <p className="text-gray-500 text-sm">Last updated: June 2025</p>

    <section className="space-y-4">
      <h2 className="text-xl text-white font-medium">Service description</h2>
      <p>
        FractoLabs provides AI-powered digital employee software and related services. Features, pricing, and
        availability may change. By using our websites or services, you agree to these terms.
      </p>
    </section>

    <section className="space-y-4">
      <h2 className="text-xl text-white font-medium">Acceptable use</h2>
      <p>
        You agree to use FractoLabs services lawfully and not to misuse the platform, attempt unauthorized access, or
        interfere with other users or systems.
      </p>
    </section>

    <section className="space-y-4">
      <h2 className="text-xl text-white font-medium">Disclaimer</h2>
      <p>
        FractoLabs services are provided &quot;as is&quot; without warranties of any kind, express or implied. AI
        outputs may require human review; you remain responsible for business decisions and compliance in your
        industry.
      </p>
    </section>

    <section className="space-y-4">
      <h2 className="text-xl text-white font-medium">Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, FractoLabs shall not be liable for indirect, incidental, special, or
        consequential damages arising from your use of our services.
      </p>
    </section>

    <section className="space-y-4">
      <h2 className="text-xl text-white font-medium">Contact</h2>
      <p>
        Questions about these terms:{" "}
        <a href="mailto:support@fractolabs.com" className="text-teal-400 hover:text-teal-300">
          support@fractolabs.com
        </a>
        .
      </p>
    </section>
  </LegalPageShell>
);

export default TermsPage;
